import * as React from "react";

export const TermsAndPrivacy = () => (
  <div className="unselectable text-placeholder mt-10 text-base">
    By signing up, you agree to the Replo
    <a
      className="text-primary px-1 no-underline"
      href="https://replo.app/terms"
      target="_blank"
      rel="noreferrer"
    >
      Terms and Conditions
    </a>
    and
    <a
      className="text-primary px-1 no-underline"
      href="https://replo.app/privacy"
      target="_blank"
      rel="noreferrer"
    >
      Privacy Policy
    </a>
  </div>
);
